/**
 * pages頁需要事先宣告處理位置
 *
 *
 */

//import views

export const About = () => import("@/views/about");
export const InfoList = () => import("@/views/info/list");
export const InfoPage = () => import("@/views/info/page");
export const BrandRepair = () => import("@/views/brand/repair");
export const BrandInspection = () => import("@/views/brand/inspection");
export const CarList = () => import("@/views/car/list");
export const CarPage = () => import("@/views/car/page");
export const CarForm = () => import("@/views/car/form");
export const CarSuccess = () => import("@/views/car/success");
export const CarSuccessLogin = () =>
  import("@/views/car/success/success_login");
export const CarSuccessJoin = () => import("@/views/car/success/success_join");
export const SoldEstimate = () => import("@/views/sold/estimate");
export const SoldSearch = () => import("@/views/sold/search");
export const SoldSuccess = () => import("@/views/sold/success");
export const NotFound = () => import("@/views/NotFound.vue");
